export * from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ConceptSelector.vue?vue&type=template&id=704bdc82&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/File/Quantification/ConceptSelector.vue?vue&type=template&id=704bdc82&scoped=true
// module id = 1936
// module chunks = 31